import { Box } from "@mui/material";
import { styled } from "@mui/system";
import defaultLeftPage from "@Assets/leftGridBG.jpg";

const FormPageTemplateStyles = styled(Box)(
  ({ theme, textDown, textColor, leftGridBG, isSmallScreen }) => ({
    "&.formPageTemplate": {
      backgroundColor: theme.palette.grey.light,
      height: `calc(100vh)`,
    },
    "& .gridContainer": {
      fontSize: theme.typography.pxToRem(15),
      overflow: "hidden", // Prevent the whole page from scrolling
      height: "100%",
      width: "100%",
      paddingTop: 0,
    },
    "& .leftGridWrapper": {
      backgroundImage: `url(${leftGridBG})`,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center center",
      backgroundSize: "cover",
      position: "fixed",
      height: "100vh",
      width: "33.33%", // Fixed width for the left grid
      overflow: "hidden",
      color: textColor ? textColor : theme.palette.grey[800],
      display: "flex",
      alignItems: textDown ? "flex-end" : "initial",
    },
    "& .rightGridWrapper": {
      marginLeft: isSmallScreen ? "0" : "33.33%", // Adjust margin to the width of the left grid
      width: isSmallScreen ? "100%" : "66.67%", // Remaining width for the right grid
      height: `calc(100vh - ${theme.navbar.navbarHeight}px)`, // Adjust height to exclude navbar and footer height
      // marginTop: "65px", // Offset for navbar height
      overflowY: "auto", // Enable vertical scrolling
      zIndex: 0,
    },
    "& .formWrapper": {
      display: "flex",
      minHeight: "100%", // Ensure the wrapper takes full height
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(2),

    },
    "& .inputContainer": {
      width: "60%",
    },
    "& .submissionRow": {
      right: theme.spacing(2),
    },
    "& .submissionBoxContainer": {
      display: "flex",
      justifyContent: "flex-end",
    },
    "& .submissionButton": {
      width: theme.spacing(9),
      marginLeft: theme.spacing(2),
    },
    "& .submissionBox": {
      display: "flex",
      justifyContent: "flex-end",
      textAlign: "right",
      width: "79.1%",
      paddingTop: theme.spacing(3),
      position: "static",
    },
  })
);

export default FormPageTemplateStyles;
